export const DDI_OPTIONS = [
    // Brasil em primeiro
    { label: "+55", value: "55", mask: "(00) 00000-0000", country: "Brasil" },

    // Estados Unidos/Canadá
    { label: "+1", value: "1", mask: "(000) 000-0000", country: "EUA/Canadá" },

    // América do Sul
    { label: "+54", value: "54", mask: "000 0000-0000", country: "Argentina" },
    { label: "+591", value: "591", mask: "000 00000", country: "Bolívia" },
    { label: "+56", value: "56", mask: "0 0000 0000", country: "Chile" },
    { label: "+57", value: "57", mask: "000 0000000", country: "Colômbia" },
    { label: "+593", value: "593", mask: "00 000 0000", country: "Equador" },
    { label: "+592", value: "592", mask: "000 0000", country: "Guiana" },
    {
        label: "+594",
        value: "594",
        mask: "000 00 00 00",
        country: "Guiana Francesa"
    },
    { label: "+595", value: "595", mask: "0000 000000", country: "Paraguai" },
    { label: "+51", value: "51", mask: "000 000000", country: "Peru" },
    { label: "+597", value: "597", mask: "000-000", country: "Suriname" },
    { label: "+598", value: "598", mask: "000 000 000", country: "Uruguai" },
    { label: "+58", value: "58", mask: "0000-0000000", country: "Venezuela" },

    // América Central e Caribe
    { label: "+501", value: "501", mask: "000-0000", country: "Belize" },
    { label: "+506", value: "506", mask: "0000 0000", country: "Costa Rica" },
    { label: "+53", value: "53", mask: "0 000 0000", country: "Cuba" },
    { label: "+503", value: "503", mask: "0000 0000", country: "El Salvador" },
    { label: "+502", value: "502", mask: "0000 0000", country: "Guatemala" },
    { label: "+509", value: "509", mask: "00 00 0000", country: "Haiti" },
    { label: "+504", value: "504", mask: "0000 0000", country: "Honduras" },
    { label: "+52", value: "52", mask: "000 000 0000", country: "México" },
    { label: "+505", value: "505", mask: "0000 0000", country: "Nicarágua" },
    { label: "+507", value: "507", mask: "0000-0000", country: "Panamá" },
    {
        label: "+1-869",
        value: "1-869",
        mask: "000-0000",
        country: "São Cristóvão e Nevis"
    },
    {
        label: "+1-758",
        value: "1-758",
        mask: "000-0000",
        country: "Santa Lúcia"
    },
    {
        label: "+1-784",
        value: "1-784",
        mask: "000-0000",
        country: "São Vicente e Granadinas"
    },

    // Resto do mundo em ordem alfabética
    { label: "+93", value: "93", mask: "00 000 0000", country: "Afeganistão" },
    {
        label: "+27",
        value: "27",
        mask: "00 000 0000",
        country: "África do Sul"
    },
    { label: "+355", value: "355", mask: "000 000 0000", country: "Albânia" },
    { label: "+49", value: "49", mask: "000 00000000", country: "Alemanha" },
    { label: "+376", value: "376", mask: "000 000", country: "Andorra" },
    { label: "+244", value: "244", mask: "000 000 000", country: "Angola" },
    {
        label: "+966",
        value: "966",
        mask: "0 000 0000",
        country: "Arábia Saudita"
    },
    {
        label: "+213",
        value: "213",
        mask: "000 00 00 00 00",
        country: "Argélia"
    },
    { label: "+374", value: "374", mask: "00 000 000", country: "Armênia" },
    { label: "+61", value: "61", mask: "0000 000 000", country: "Austrália" },
    { label: "+43", value: "43", mask: "0000 000000", country: "Áustria" },
    {
        label: "+994",
        value: "994",
        mask: "00 000 00 00",
        country: "Azerbaijão"
    },
    { label: "+973", value: "973", mask: "0000 0000", country: "Bahrein" },
    { label: "+880", value: "880", mask: "0000-000000", country: "Bangladesh" },
    { label: "+32", value: "32", mask: "000 00 00 00", country: "Bélgica" },
    { label: "+229", value: "229", mask: "00 00 00 00", country: "Benin" },
    {
        label: "+375",
        value: "375",
        mask: "00 000 00 00",
        country: "Bielorrússia"
    },
    {
        label: "+387",
        value: "387",
        mask: "00 000 000",
        country: "Bósnia e Herzegovina"
    },
    { label: "+267", value: "267", mask: "00 000 000", country: "Botsuana" },
    { label: "+673", value: "673", mask: "000 0000", country: "Brunei" },
    { label: "+359", value: "359", mask: "000 000 000", country: "Bulgária" },
    {
        label: "+226",
        value: "226",
        mask: "00 00 00 00",
        country: "Burkina Faso"
    },
    { label: "+257", value: "257", mask: "00 00 0000", country: "Burundi" },
    { label: "+975", value: "975", mask: "00 00 00 00", country: "Butão" },
    { label: "+238", value: "238", mask: "000 00 00", country: "Cabo Verde" },
    { label: "+855", value: "855", mask: "00 000 000", country: "Camboja" },
    { label: "+237", value: "237", mask: "0000 000 00", country: "Camarões" },
    { label: "+974", value: "974", mask: "0000 0000", country: "Catar" },
    { label: "+235", value: "235", mask: "00 00 00 00", country: "Chade" },
    { label: "+86", value: "86", mask: "000 0000 0000", country: "China" },
    { label: "+357", value: "357", mask: "00 000000", country: "Chipre" },
    { label: "+269", value: "269", mask: "00000 0000", country: "Comores" },
    { label: "+242", value: "242", mask: "00 000 0000", country: "Congo" },
    {
        label: "+243",
        value: "243",
        mask: "000 000 000",
        country: "Congo (Rep. Dem.)"
    },
    {
        label: "+82",
        value: "82",
        mask: "00-000-0000",
        country: "Coreia do Sul"
    },
    {
        label: "+225",
        value: "225",
        mask: "00 000 000",
        country: "Costa do Marfim"
    },
    { label: "+385", value: "385", mask: "000 000 000", country: "Croácia" },
    { label: "+45", value: "45", mask: "00 00 00 00", country: "Dinamarca" },
    { label: "+253", value: "253", mask: "00 00 00 00", country: "Djibuti" },
    { label: "+20", value: "20", mask: "0000 000 000", country: "Egito" },
    {
        label: "+971",
        value: "971",
        mask: "000 000 0000",
        country: "Emirados Árabes Unidos"
    },
    { label: "+291", value: "291", mask: "0 000 000", country: "Eritreia" },
    { label: "+421", value: "421", mask: "000 000 000", country: "Eslováquia" },
    { label: "+386", value: "386", mask: "00 000 000", country: "Eslovênia" },
    { label: "+34", value: "34", mask: "(000) 000 000", country: "Espanha" },
    { label: "+372", value: "372", mask: "0000 0000", country: "Estônia" },
    { label: "+251", value: "251", mask: "00 000 0000", country: "Etiópia" },
    { label: "+63", value: "63", mask: "0000 000 0000", country: "Filipinas" },
    { label: "+358", value: "358", mask: "000 0000000", country: "Finlândia" },
    { label: "+33", value: "33", mask: "0 00 00 00 00", country: "França" },
    { label: "+241", value: "241", mask: "0 00 00 00", country: "Gabão" },
    { label: "+220", value: "220", mask: "000 0000", country: "Gâmbia" },
    { label: "+233", value: "233", mask: "000 000 0000", country: "Gana" },
    { label: "+995", value: "995", mask: "000 00 00 00", country: "Geórgia" },
    { label: "+30", value: "30", mask: "000 000 0000", country: "Grécia" },
    { label: "+299", value: "299", mask: "00 00 00", country: "Groenlândia" },
    { label: "+224", value: "224", mask: "000 00 00 00", country: "Guiné" },
    {
        label: "+245",
        value: "245",
        mask: "000 000 000",
        country: "Guiné-Bissau"
    },
    {
        label: "+240",
        value: "240",
        mask: "000 000 000",
        country: "Guiné Equatorial"
    },
    { label: "+31", value: "31", mask: "00 00000000", country: "Holanda" },
    { label: "+852", value: "852", mask: "0000 0000", country: "Hong Kong" },
    { label: "+36", value: "36", mask: "00 000 0000", country: "Hungria" },
    { label: "+967", value: "967", mask: "000 000 000", country: "Iémen" },
    { label: "+677", value: "677", mask: "00000", country: "Ilhas Salomão" },
    { label: "+91", value: "91", mask: "00000 00000", country: "Índia" },
    { label: "+62", value: "62", mask: "0000-000-000", country: "Indonésia" },
    { label: "+98", value: "98", mask: "0000 000 0000", country: "Irã" },
    { label: "+964", value: "964", mask: "0000 000 0000", country: "Iraque" },
    { label: "+353", value: "353", mask: "000 000 0000", country: "Irlanda" },
    { label: "+354", value: "354", mask: "000 0000", country: "Islândia" },
    { label: "+972", value: "972", mask: "00-000-0000", country: "Israel" },
    { label: "+81", value: "81", mask: "00-0000-0000", country: "Japão" },
    { label: "+962", value: "962", mask: "0 0000 0000", country: "Jordânia" },
    { label: "+965", value: "965", mask: "0000 0000", country: "Kuwait" },
    { label: "+856", value: "856", mask: "20 000 000", country: "Laos" },
    { label: "+266", value: "266", mask: "0000 0000", country: "Lesoto" },
    { label: "+371", value: "371", mask: "00 000 000", country: "Letônia" },
    { label: "+961", value: "961", mask: "00 000 000", country: "Líbano" },
    { label: "+231", value: "231", mask: "00 000 000", country: "Libéria" },
    { label: "+218", value: "218", mask: "00 0000000", country: "Líbia" },
    { label: "+370", value: "370", mask: "000 00 000", country: "Lituânia" },
    { label: "+352", value: "352", mask: "000 000 000", country: "Luxemburgo" },
    { label: "+853", value: "853", mask: "0000 0000", country: "Macau" },
    { label: "+389", value: "389", mask: "00 000 000", country: "Macedônia" },
    {
        label: "+261",
        value: "261",
        mask: "00 00 000 00",
        country: "Madagascar"
    },
    { label: "+60", value: "60", mask: "00-0000 0000", country: "Malásia" },
    { label: "+265", value: "265", mask: "0 999 999 999", country: "Malaui" },
    { label: "+960", value: "960", mask: "000-0000", country: "Maldivas" },
    { label: "+223", value: "223", mask: "00 00 00 00", country: "Mali" },
    { label: "+356", value: "356", mask: "0000 0000", country: "Malta" },
    { label: "+212", value: "212", mask: "0000-000000", country: "Marrocos" },
    { label: "+230", value: "230", mask: "000 0000", country: "Maurício" },
    { label: "+222", value: "222", mask: "00 00 00 00", country: "Mauritânia" },
    { label: "+95", value: "95", mask: "00 000 000", country: "Mianmar" },
    { label: "+373", value: "373", mask: "0000 0000", country: "Moldávia" },
    { label: "+377", value: "377", mask: "00 00 00 00", country: "Mônaco" },
    { label: "+976", value: "976", mask: "00 00 0000", country: "Mongólia" },
    { label: "+382", value: "382", mask: "00 000 000", country: "Montenegro" },
    { label: "+258", value: "258", mask: "00 000 0000", country: "Moçambique" },
    { label: "+264", value: "264", mask: "00 000 0000", country: "Namíbia" },
    { label: "+977", value: "977", mask: "000-0000000", country: "Nepal" },
    { label: "+234", value: "234", mask: "000 000 0000", country: "Nigéria" },
    { label: "+227", value: "227", mask: "00 00 00 00", country: "Níger" },
    { label: "+47", value: "47", mask: "000 00 000", country: "Noruega" },
    {
        label: "+64",
        value: "64",
        mask: "000 000 0000",
        country: "Nova Zelândia"
    },
    { label: "+968", value: "968", mask: "00 000000", country: "Omã" },
    { label: "+92", value: "92", mask: "0000 0000000", country: "Paquistão" },
    { label: "+48", value: "48", mask: "000 000 000", country: "Polônia" },
    { label: "+351", value: "351", mask: "000 000 000", country: "Portugal" },
    { label: "+254", value: "254", mask: "0000 000000", country: "Quênia" },
    {
        label: "+996",
        value: "996",
        mask: "000 000 000",
        country: "Quirguistão"
    },
    { label: "+44", value: "44", mask: "0000 000000", country: "Reino Unido" },
    {
        label: "+236",
        value: "236",
        mask: "00 00 00 00",
        country: "República Centro-Africana"
    },
    {
        label: "+420",
        value: "420",
        mask: "000 000 000",
        country: "República Tcheca"
    },
    { label: "+40", value: "40", mask: "0000 000 000", country: "Romênia" },
    { label: "+250", value: "250", mask: "0000 00000", country: "Ruanda" },
    {
        label: "+7",
        value: "7",
        mask: "000 000-00-00",
        country: "Rússia/Cazaquistão"
    },
    { label: "+685", value: "685", mask: "00 000", country: "Samoa" },
    { label: "+221", value: "221", mask: "00 000 0000", country: "Senegal" },
    { label: "+232", value: "232", mask: "00 000000", country: "Serra Leoa" },
    { label: "+381", value: "381", mask: "00 000 000", country: "Sérvia" },
    { label: "+248", value: "248", mask: "0 000 000", country: "Seychelles" },
    { label: "+65", value: "65", mask: "0000 0000", country: "Singapura" },
    { label: "+963", value: "963", mask: "0999 999 999", country: "Síria" },
    { label: "+252", value: "252", mask: "00 000000", country: "Somália" },
    { label: "+94", value: "94", mask: "0 00 000 000", country: "Sri Lanka" },
    {
        label: "+268",
        value: "268",
        mask: "00 00 00 00",
        country: "Suazilândia"
    },
    { label: "+249", value: "249", mask: "0 00 000 0000", country: "Sudão" },
    {
        label: "+211",
        value: "211",
        mask: "00 000 0000",
        country: "Sudão do Sul"
    },
    { label: "+46", value: "46", mask: "00-000 00 00", country: "Suécia" },
    { label: "+41", value: "41", mask: "00 000 00 00", country: "Suíça" },
    { label: "+886", value: "886", mask: "09 9999 9999", country: "Taiwan" },
    {
        label: "+992",
        value: "992",
        mask: "900 00 00 00",
        country: "Tajiquistão"
    },
    { label: "+66", value: "66", mask: "000-000-0000", country: "Tailândia" },
    { label: "+255", value: "255", mask: "000 000 000", country: "Tanzânia" },
    { label: "+228", value: "228", mask: "00 00 00 00", country: "Togo" },
    { label: "+216", value: "216", mask: "00 000 000", country: "Tunísia" },
    { label: "+90", value: "90", mask: "(000) 000 00 00", country: "Turquia" },
    {
        label: "+993",
        value: "993",
        mask: "0 00 000000",
        country: "Turcomenistão"
    },
    { label: "+380", value: "380", mask: "(00) 000 00 00", country: "Ucrânia" },
    { label: "+256", value: "256", mask: "0000 000000", country: "Uganda" },
    {
        label: "+998",
        value: "998",
        mask: "00 000 0000",
        country: "Uzbequistão"
    },
    { label: "+678", value: "678", mask: "00 00000", country: "Vanuatu" },
    { label: "+379", value: "379", mask: "000 000 000", country: "Vaticano" },
    { label: "+84", value: "84", mask: "000 000 00 00", country: "Vietnã" },
    { label: "+260", value: "260", mask: "000 0000000", country: "Zâmbia" },
    { label: "+263", value: "263", mask: "000 000 0000", country: "Zimbábue" }
];
